import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service.ts';
import { FormProvider, useForm } from 'react-hook-form';
import { Content } from './content.popup.tsx';
import { yupResolver } from '@hookform/resolvers/yup';
import { createValidationSchema } from './clientDetails.schema.ts';

const validationSchema = createValidationSchema();
export class ClientDetailsPopup extends Popup<IClientDetailsPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const formMethods = useForm<IFormData>({
        defaultValues: {
          id: '',
          note: null,
          email: '',
          isDeactivated: false,
          name: '',
          orderAddNewItem: false,
          orderShowPrice: false,
          orderNoDelivery: false,
          standardOrderEdit: false,
          whyDeactivated: null,
        },
        resolver: yupResolver(validationSchema),
      });
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 665, minWidth: 665, width: '100%' },
          '& > div > div > div': { padding: 20 },
        }));
      }, []);
      const [field, setField] = useState('');
      useEffect(() => {
        stream.actionListener('open').subscribe(({ values, field }) => {
          formMethods.reset(values);
          setField(field || '');
        });
      }, []);
      return (
        <FormProvider {...formMethods}>
          <SWrapper stream={stream} popupTitle={t('settings.client_details')}>
            <Content {...{ stream, field }} />
          </SWrapper>
        </FormProvider>
      );
    };
  }
}

export interface IFormData {
  id: string;
  note: string | null | undefined;
  name: string;
  orderAddNewItem: boolean;
  orderShowPrice: boolean;
  orderNoDelivery: boolean;
  standardOrderEdit: boolean;
  email: string;
  isDeactivated: boolean;
  whyDeactivated: string | null | undefined;
}
export interface IClientDetailsPopup {
  action: TPopupDefaultActions;
  values: IFormData;
  field?: string;
}
